<template>
  <div :style="containerStyle">
    <!-- 有効期限切れ -->
    <div v-if="expired" :style="messageStyle">
      <h2 :style="titleStyle">リンクの有効期限切れ</h2>
      <p :style="textStyle">このリンクは有効期限が切れています。</p>
    </div>

    <!-- 404 -->
    <div v-else-if="notFound" :style="messageStyle">
      <h2 :style="titleStyle">リンクが見つかりません</h2>
      <p :style="textStyle">指定されたリンクは存在しません。</p>
      <p :style="textStyle">URLをご確認のうえ、再度お試しください。</p>
    </div>

    <!-- エラー -->
    <div v-else-if="error" :style="messageStyle">
      <h2 :style="titleStyle">エラーが発生しました</h2>
      <p :style="textStyle">しばらくしてから再度お試しください。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShortUrlRedirect',
  data() {
    return {
      loading: true,
      expired: false,
      notFound: false,
      error: false,
    };
  },
  computed: {
    containerStyle() {
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        fontFamily: '"Helvetica Neue", Arial, "Hiragino Sans", sans-serif',
      };
    },
    messageStyle() {
      return {
        textAlign: 'center',
        padding: '40px 20px',
        maxWidth: '400px',
      };
    },
    titleStyle() {
      return {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '16px',
      };
    },
    textStyle() {
      return {
        fontSize: '14px',
        color: '#666',
        lineHeight: '1.6',
        margin: '8px 0',
      };
    },
  },
  async mounted() {
    const code = this.$route.params.code;
    if (!code) {
      this.loading = false;
      this.notFound = true;
      return;
    }

    try {
      const res = await this.axios.get('/v1/shortUrl/resolve', { params: { code } });
      if (res.data?.status === 200 && res.data?.url) {
        // 履歴に短縮URLを残さない（「戻る」でまたリダイレクトされるのを防ぐ。#4031）
        window.location.replace(res.data.url);
      } else if (res.data?.status === 410) {
        this.loading = false;
        this.expired = true;
      } else if (res.data?.status === 404) {
        this.loading = false;
        this.notFound = true;
      } else {
        this.loading = false;
        this.error = true;
      }
    } catch (err) {
      this.loading = false;
      if (err.response?.data?.status === 410) {
        this.expired = true;
      } else if (err.response?.data?.status === 404) {
        this.notFound = true;
      } else {
        this.error = true;
      }
    }
  },
};
</script>
